module.exports = __webpack_public_path__ + "static/media/logo.85cc9d3c.png";